// 路由模式
export const ROUTER_MODE = 'history'; // history | hash
